import React from 'react';
import './loading.css';

const LoadingPage = () => {
  return (
    <div className="loading-container">
      {/* Option 1: Simple Spinner */}
      <div className="spinner"></div>
      
      {/* Option 2: Animated Text */}
      <div className="loading-text">
        <span>L</span>
        <span>O</span>
        <span>A</span>
        <span>D</span>
        <span>I</span>
        <span>N</span>
        <span>G</span>
      </div>
      
      {/* Option 3: Progress Bar */}
      <div className="progress-container">
        <div className="progress-bar"></div>
      </div>
    </div>
  );
};

export default LoadingPage;